export default {
  // 公告類型
  TYPE_INFORMATION: 'information', // 消息
  TYPE_EVENT: 'event', // 活動
  TYPE_POST: 'post', // 公告
}